<template>
    <v-dialog max-width="500px"  v-model="show">
    <DlgMessage ref="dlgMsg" @dlgClose="dlgClose"></DlgMessage>
        <v-card>
          <v-toolbar flat dark color="panel1">
            <v-toolbar-title>Add New Receipt Template</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="show=false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
            <div class="pa-5">

                            <v-row no-gutters>
                    <v-col cols="12">

                <v-form ref="mainForm">
                    <v-text-field 
                        v-model="form.rt_code" label="Code" :rules="inputRules" 
                        outlined                          
                    ></v-text-field>
                    <v-text-field 
                        v-model="form.rt_name" label="Name" :rules="inputRules" 
                        outlined                          
                    ></v-text-field>
                    <v-select
                        v-model = "form.receipt_type_code"
                        :items="rtTypeList"
                        item-text="description"
                        item-value="code"
                        label="Type"
                        standard
                        :rules="inputRules"
                        outlined
                        v-if="show" autofocus
                    ></v-select>

                    <v-spacer></v-spacer>
                </v-form>
                    </v-col>
                            </v-row>
            </div>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="cbtnSave" dark @click="save">
                    <v-icon left dark>mdi-check</v-icon>
                    Submit
                </v-btn>
                <v-btn class="ml-2" color="cbtnRed" dark @click="show=false">
                    <v-icon left dark>mdi-close</v-icon>
                    Close
                </v-btn>
            </v-card-actions>

          </v-card>
    </v-dialog>

</template>

<script>
import DlgMessage from '@/components/DlgMessage'
import ApEdcRcptService from "@/services/ApEdcRcptService"
import ApParameterService from "@/services/ApParameterService"
export default {
    name: "DlgEdcReceiptTemplateAdd",
    props: {
        visible:Boolean,
    },      
    components:{DlgMessage},
    computed: {
      show: {
        get () {
          return this.visible
        },
        set (value) {
           if (!value) {
                this.$emit('close')
           }
        }
      },
      outletListFiltered(){
          return this.outletList.filter(item => item.merchant_id === this.form.merchant_id)
        },

      
    },
    data(){
        return{
            dialog: false,
            form:{
                login_id: "",
                rt_code: "",
                rt_name: "",
                receipt_type_code: "tx",
                status: "ACTIVE"
            },
            rtTypeList: [],
            error_message:'',
            error_code: '200',
            inputRules: [
             v => !!v || 'This field is required'
            ]
        }
    },
    async created() {
//        this.$refs.mainForm.reset()
        this.getParameter();
      //this.viewMerchantEdc();
    },
     
    methods:{
   dlgShow(){
    },
    dlgClose(){
        //console.log(this.respCode);
        
        if(this.respCode == 200){
            this.form.c_code = "";
            this.form.c_name = "";
            this.form.sequence = 0;
            this.show = false;
        }
            
    },                
        async save(){
            //console.log(this.form);
            if(this.$refs.mainForm.validate()) {
                try{
                
                    ApEdcRcptService.insert_edc_rcpt_template(this.form).then(() => {
                        //console.log(res);
                        this.$refs.dlgMsg.showDlgBox(true,'success','New EDC','Success.');
                    }).catch((e)=>{
                        //console.log(e.response);
                        this.$refs.dlgMsg.showDlgBox(true,'error','New EDC',e.response.data.error_message);
                    })
                    ;
                } catch(e) {
                    this.loadingFlag = false
                    this.$refs.dlgMsg.showDlgBox(true,'error','New EDC','Unknown Error');
                    
                } 
            }

        },
        async getParameter(){
            try{
                let parameter = {login_id:"",param_type:"add-edc_rcpt_template"}
                ApParameterService.get_parameter(parameter).then((res) => {
                    this.rtTypeList = res.data.rtTypeList;
                    //console.log(res.data);
                    
                }).catch((e)=>{
                    //console.log(e.response);
                    this.$refs.dlgMsg.showDlgBox(true,'error','EDC Receipt Template',e.response.data.error_message);
                })
                ;
            } catch(e) {
                //console.log(e);
                //this.$refs.dlgMsg.showDlgBox(true,'error','Supplier','Unknown Error');
            }
        },
        
    }
}    

</script>